import React from 'react'
import { Button } from 'react-bootstrap'
import CustomSpinner from './CustomSpinner';

const CustomButton = ({
    isSaving, 
    title,
    icon
}) => {
  return (
    <Button className='btn-custom my-3' disabled={isSaving} type='submit'>
        {
            isSaving ? (
                <CustomSpinner />
            ) : (
                <>
                    {icon && <span className='icon'>{icon}</span>}
                    <span className='title'>{title}</span>
                </>
            )
        }
    </Button>
  )
}

export default CustomButton